// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8048bf9f","453":"eb76f4f3","455":"2453897e","977":"c6920f9f"}[chunkId] + ".chunk.js";
};